import mapFunction from './mapResources';

export default mapFunction('material_types', {
    isFetching: false,
    items: [] 
});
